import { radarList, updateNote } from '@/mocks/home';

export default function Radar() {
  return (
    <section id="radar" className="mx-auto max-w-6xl scroll-mt-16 px-4 py-10 md:px-6 md:py-14">
      <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
        <div>
          <span className="text-stamp text-xs text-primary-600">UPDATE RADAR</span>
          <h3 className="font-heading mt-2 text-2xl font-black text-foreground-950 md:text-3xl">
            更新雷达 · 正在深扒什么
          </h3>
          <p className="mt-2 max-w-xl text-sm text-foreground-600">{updateNote}</p>
        </div>
        <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-accent-400 bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
          <i className="ri-broadcast-line" />
          26 个专题持续跟进中
        </span>
      </div>

      <div className="mt-6 grid gap-3 md:mt-8 lg:grid-cols-2">
        {radarList.map((r) => (
          <div
            key={r.label}
            className="rounded-lg border border-secondary-200 bg-background-50 p-5"
          >
            <div className="flex items-center justify-between gap-2">
              <h4 className="flex-1 text-sm font-bold text-foreground-950">
                <a href="#collections" className="hover:text-primary-700">
                  {r.label}
                </a>
              </h4>
              <span className="whitespace-nowrap rounded-sm bg-secondary-100 px-2 py-0.5 text-xs text-foreground-600">
                {r.phase}
              </span>
              <span className="whitespace-nowrap text-xs text-foreground-400">{r.date}</span>
            </div>
            <div className="mt-4 flex items-center gap-3">
              <div className="h-2 flex-1 overflow-hidden rounded-full bg-secondary-200">
                <div
                  className="h-full rounded-full bg-gradient-to-r from-primary-600 to-primary-400"
                  style={{ width: `${r.ratio}%` }}
                />
              </div>
              <span className="font-heading w-10 text-right text-sm font-black text-primary-700">
                {r.ratio}%
              </span>
            </div>
          </div>
        ))}

        <div className="flex flex-col items-start justify-between gap-3 rounded-lg border border-primary-200 bg-primary-50 p-5 lg:flex-row lg:items-center">
          <div>
            <p className="flex items-center gap-2 font-bold text-foreground-950">
              <i className="ri-notification-3-line text-primary-600" />
              新细节会原位置追加
            </p>
            <p className="mt-1 text-sm text-foreground-600">
              不重复建专题，直接在对应集合下更新进度并在速递区同步提示。
            </p>
          </div>
          <a
            href="#flash"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 hover:bg-primary-600"
          >
            查看最新速递
            <i className="ri-arrow-right-line ml-1" />
          </a>
        </div>
      </div>
    </section>
  );
}